@if (!loading) {
  <img class="icon open-icon" src="/content/icons/open-new-page.svg" (click)="getAndOpenInvoicePDF(invoiceDocumentId, businessArea)" />
}
@if (loading) {
  <fa-icon class="open-icon" icon="spinner" animation="spin" />
}
@if (error) {
  <fa-icon class="open-icon" icon="circle-exclamation" title="{{this.errorMessage}}" />
}
